import React from 'react';

const ProgressIndicator = ({ text = 'Loading...', isLoading = false }) => {
  return (
    <div className={`fixed inset-0 flex items-center justify-center ${!isLoading ? 'hidden' : ''}`}>
      <div className="flex flex-col items-center gap-2">
        <div 
          className={`w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-white
            ${isLoading ? 'animate-spin' : ''}`}
          style={{ 
            animationDuration: '1s',
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite',
            width: "106.26px",
            height: "106.26px"
          }}
        />
        <span className="text-gray-700 text-sm font-extrabold font-sans">{text}</span>
      </div>
    </div>
  );
};

export default ProgressIndicator;